module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('el-form', {
    ref: "queryForm",
    attrs: {
      "size": "mini",
      "inline": true,
      "label-position": "left",
      "label-width": _vm.queryFormLabelWidth,
      "model": _vm.queryForm
    }
  }, [(_vm.autocompleteData.schoolsList.length > 0) ? _c('el-form-item', {
    attrs: {
      "label": "学校名称",
      "prop": "commercial_id"
    }
  }, [_c('el-autocomplete', {
    attrs: {
      "clearable": "",
      "value-key": "school_name",
      "placeholder": "请输入",
      "trigger-on-focus": false,
      "fetch-suggestions": function (query, cb) { return _vm.querySchoolSearch(query, cb, 'schoolsList'); }
    },
    on: {
      "clear": function($event) {
        return _vm.clearSelect('schoolsList', 2)
      },
      "select": function (item) { return _vm.handleSelect(item, 'schoolsList'); }
    },
    model: {
      value: (_vm.autocompleteData.school_name),
      callback: function($$v) {
        _vm.$set(_vm.autocompleteData, "school_name", $$v)
      },
      expression: "autocompleteData.school_name"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.autocompleteData.shopsList.length > 0) ? _c('el-form-item', {
    attrs: {
      "label": "店铺名称",
      "prop": "shop_id"
    }
  }, [_c('el-autocomplete', {
    attrs: {
      "clearable": "",
      "value-key": "shop_name",
      "placeholder": "请输入",
      "trigger-on-focus": false,
      "fetch-suggestions": function (query, cb) { return _vm.querySchoolSearch(query, cb, 'shopsList'); }
    },
    on: {
      "clear": function($event) {
        return _vm.clearSelect('shopsList', 2)
      },
      "select": function (item) { return _vm.handleSelect(item, 'shopsList'); }
    },
    model: {
      value: (_vm.autocompleteData.shop_name),
      callback: function($$v) {
        _vm.$set(_vm.autocompleteData, "shop_name", $$v)
      },
      expression: "autocompleteData.shop_name"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "配送类型",
      "prop": "orderType"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.queryForm.orderType),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "orderType", $$v)
      },
      expression: "queryForm.orderType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "配送单",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "自提单",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "西游侠打赏订单",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "堂食",
      "value": "3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "下单日期",
      "prop": "dateType"
    }
  }, [_c('el-date-picker', {
    staticClass: "fl ml10",
    attrs: {
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "placeholder": "请选择日期",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.queryForm.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "dateRange", $$v)
      },
      expression: "queryForm.dateRange"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "支付方式",
      "prop": "payway"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.queryForm.payway),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "payway", $$v)
      },
      expression: "queryForm.payway"
    }
  }, _vm._l((_vm.payWayList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.desc,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.fetch
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('queryForm')
      }
    }
  }, [_vm._v("重置")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('el-row', {
    staticClass: "pb20"
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.fetch('week')
      }
    }
  }, [_vm._v("周数据查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.fetch('month')
      }
    }
  }, [_vm._v("月数据查询")])], 1), _vm._v(" "), _c('el-card', {
    staticClass: "box-card mb20",
    staticStyle: {
      "background-color": "#eaf5fc"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', [_vm._v("订单总数")]), _vm._v(" "), _c('p', {
    staticClass: "red f12"
  }, [_c('span', {
    staticClass: "f20 plr2"
  }, [_vm._v(_vm._s(_vm.statisticsData.orderNumber))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', [_vm._v("结算金额")]), _vm._v(" "), _c('p', {
    staticClass: "red f12"
  }, [_c('span', {
    staticClass: "f20 plr2"
  }, [_vm._v(_vm._s(_vm.statisticsData.orderAmount))]), _vm._v("元")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', [_vm._v("退款订单总数")]), _vm._v(" "), _c('p', {
    staticClass: "red f12"
  }, [_c('span', {
    staticClass: "f20 plr2"
  }, [_vm._v(_vm._s(_vm.statisticsData.refundNumber))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', [_vm._v("退款金额总计")]), _vm._v(" "), _c('p', {
    staticClass: "red f12"
  }, [_c('span', {
    staticClass: "f20 plr2"
  }, [_vm._v(_vm._s(_vm.statisticsData.refundAmount))]), _vm._v("元")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', [_vm._v("佣金总计")]), _vm._v(" "), _c('p', {
    staticClass: "red f12"
  }, [_c('span', {
    staticClass: "f20 plr2"
  }, [_vm._v(_vm._s(_vm.statisticsData.commission))]), _vm._v("元")])])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "pb20"
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": _vm.bindExcl
    }
  }, [_vm._v("导出excel")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, _vm._l((_vm.tableColumn), function(item, index) {
    return _c('el-table-column', {
      key: index,
      attrs: {
        "prop": item.id,
        "label": item.name,
        "show-overflow-tooltip": true,
        "width": item.width,
        "fixed": item.fixed
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(item.formatter) ? _c('span', [_vm._v(_vm._s(item.formatter(scope.row)))]) : _c('span', [_vm._v(_vm._s(scope.row[item.id]))])]
        }
      }], null, true)
    })
  }), 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.queryForm.pageNo,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.queryForm.pageSize,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59468284"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/headOffice/business/order/list.vue
// module id = 915
// module chunks = 0